import React from 'react';

const AddGame = () => {
    return (
        <div>
            Add Game Page
        </div>
    );
};

export default AddGame;